import "./ProfessionalTrainingQuality.module.css";
import EnTeteDeNavigation from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import LesAccompagnements from "./sections/LesAccompagnements";
import WhyChooseEffetConseil from "./sections/WhyChooseEffetConseil";
import MySupport from "./sections/MySupport";
import ReadyToTransformProject from "@/pages/PrivacyPolicy/sections/ReadyToTransformProject";
import Footer from "@/reusable_sections/Footer";
export default function ProfessionalTrainingQualityPage() {
  return <div>
      <EnTeteDeNavigation />
      <Hero />
      <WhyChooseEffetConseil />
      <LesAccompagnements />
      <MySupport />
      <ReadyToTransformProject />
      <Footer />
    </div>;
}